export default __webpack_public_path__ + "static/media/allteam.7bdc5b26.JPG";